import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0403 from "../../../lesson/course-04/lesson-03/lesson";
import lesson0404 from "../../../lesson/course-04/lesson-04/lesson";
import lesson0405 from "../../../lesson/course-04/lesson-05/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "9ff1ba57-0e23-4437-bd15-054cdd4f191b",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "3e7dcb28-f3d3-4db0-8310-c58873fd4ddb",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
  {
    id: "9aa35f89-fc71-4ea3-a096-db76fb7fc8a7",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0405),
    lesson: lesson0405,
  },
];

export default lessonLinks;
